import { configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { combineReducers } from "redux";
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import userReducer from "./userSlice";
import languageSlice from "./languageSlice";
import courseSlice from "./courseSlice";
import lessonSlice from "./lessonSlice";
import teacherSlice from "./teacherSlice";
import classmateSlice from "./classmateSlice";
import myCoursesSlice from "./myCoursesSlice";

const persistConfig = {
  key: "counter",
  storage,
};

const reducers = combineReducers({
  user: userReducer,
  language: languageSlice,
  course: courseSlice,
  lesson: lessonSlice,
  teacher: teacherSlice,
  classmate: classmateSlice,
  myCourses: myCoursesSlice
});

const persistedReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});
